import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/public/images/navbar/logo_main-nav.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/app/[locale]/investors/components/HeroVideos.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/app/[locale]/investors/components/InvestorsHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/app/[locale]/investors/components/NavigateToContact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/app/[locale]/investors/components/NavigateToSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/app/[locale]/investors/components/ScrollToTopOnInvestors.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/app/[locale]/v1/v1.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/app/[locale]/investors/investors.module.scss");
